import { combineReducers } from 'redux';

export interface StoreState {}

const RootReducer = combineReducers({});

export default RootReducer;
